import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../config/api";
import { ColorArray } from "../config/ColorArray";
import loaderGif from "../assets/imges/loader.gif";   // <-- ADD THIS
import "./ExamType.css";

function ExamType() {
    const navigate = useNavigate();
    const [examTypes, setExamTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchTypes() {
            try {
                const res = await apiClient.get("/exam_type");

                let apiData = [];

                if (Array.isArray(res.data)) {
                    apiData = res.data;
                } else if (Array.isArray(res.data.data)) {
                    apiData = res.data.data;
                } else if (res.data.result && Array.isArray(res.data.result.data)) {
                    apiData = res.data.result.data;
                }

                setExamTypes(apiData);
            } catch (error) {
                console.log("Error:", error);
            } finally {
                setLoading(false);
            }
        }

        fetchTypes();
    }, []);

    // Handle click on exam type items
    const handleExamTypeClick = (item) => {
        console.log("Clicked item:", item); // Debug log
        
        const name = 
            item.exam_type_name ||
            item.name ||
            item.title ||
            item.exam_name ||
            "---";

        const lowerName = String(name).toLowerCase();
        const isStd8 =
            lowerName.includes("8") ||
            lowerName.includes("૮") ||
            name.includes("ધોરણ - 8") ||
            name.includes("ધોરણ - ૮") ||
            name.includes("(ધોરણ - 8)") ||
            name.includes("(ધોરણ - ૮)");

        console.log("Extracted name:", name); // Debug log

        // GnanSetu - CET (Std-5)
        if (
            lowerName.includes("cet") ||
            name.includes("CET")
        ) {
            console.log("Navigating to /navodaya-vibhag/gnansetu-cet-class-5"); // Debug log
            navigate("/navodaya-vibhag/gnansetu-cet-class-5");

        // NMMS
        } else if (lowerName.includes("nmms")) {
            console.log("Navigating to /nmms"); // Debug log
            navigate("/nmms");

        // GnanSetu (Std-8)
        } else if (
            isStd8 &&
            (lowerName.includes("gnansetu") || lowerName.includes("gnan") || name.includes("જ્ઞાન"))
        ) {
            console.log("Navigating to /navodaya-vibhag/gnansetu-class-8"); // Debug log
            navigate("/navodaya-vibhag/gnansadhna-class-8");

        // Jawahar Navodaya (Std-5)
        } else if (
            lowerName.includes("jawahar") || 
            lowerName.includes("navodaya") ||
            name.includes("જવાહર") || // Gujarati "Jawahar"
            name.includes("નવોદય") // Gujarati "Navodaya"
        ) {
            console.log("Navigating to /navodaya-vibhag/jawahar-navodaya-class-5"); // Debug log
            navigate("/navodaya-vibhag/jawahar-navodaya-class-5");
        } else {
            console.log("Clicked on exam type:", name);
            // You can add more navigation logic here for other exam types
        }
    };

    return (
        <div className="main-container">

            {/* LOADING IMAGE */}
            {loading && (
                <div className="loader-box">
                    <img src={loaderGif} alt="Loading..." className="loader-img" />
                </div>
            )}

            {!loading && examTypes.length === 0 && (
                <p className="no-data-text">No Exam Type Found</p>
            )}

            {/* SHOW BUTTONS AFTER LOADING */}
            {!loading && (
                <div className="button-list">
                    {examTypes.map((item, index) => {
                        const name =
                            item.exam_type_name ||
                            item.name ||
                            item.title ||
                            item.exam_name ||
                            "---";

                        const { color1, color2 } =
                            ColorArray[index % ColorArray.length];

                        const buttonStyle = {
                            background: `linear-gradient(to bottom, ${color1}, ${color2})`,
                        };

                        return (
                            <button
                                key={index}
                                className="btn"
                                style={buttonStyle}
                                onClick={() => handleExamTypeClick(item)}
                            >
                                {name}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default ExamType;
